import { api } from './client.js';

export const organizationsApi = {
  list:   ()         => api.get('/api/admin/orgs'),
  get:    (id)       => api.get(`/api/admin/orgs/${id}`),
  create: (data)     => api.post('/api/admin/orgs', data),
  update: (id, data) => api.put(`/api/admin/orgs/${id}`, data),
  delete: (id)       => api.delete(`/api/admin/orgs/${id}`),
};
